import { render, staticRenderFns } from "./Impacto.vue?vue&type=template&id=13df436b&scoped=true&"
import script from "./Impacto.vue?vue&type=script&lang=ts&"
export * from "./Impacto.vue?vue&type=script&lang=ts&"
import style0 from "./Impacto.vue?vue&type=style&index=0&id=13df436b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13df436b",
  null
  
)

export default component.exports